<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="8" :sm="24">
              <a-form-item label="课程标题" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入课程标题" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="课程名称" prop="courseName">
                <a-input v-model="queryParam.courseName" placeholder="请输入课程名称" @pressEnter="handleQuery" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">


            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd(queryParam.courseId)" v-hasPermi="['catalogue:catalogue:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['catalogue:catalogue:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['catalogue:catalogue:remove']">
          <a-icon type="delete" />删除
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['catalogue:catalogue:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <!-- <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" /> -->
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id" :scroll="{x: 1500,y:'calc(100vh - 400px)'}" 
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
          {{(current-1)*size+index+1}}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="isRelease" slot-scope="text, record">
            <a-popconfirm ok-text="是" cancel-text="否" @confirm="confirmRelease(record,record.isRelease)"
                          @cancel="cancelRelease()">
              <span slot="title" class="card-title">
                <b>{{ record.isRelease == 1 ? '是否禁用' : '是否启用' }} </b>?
               </span>
              <a-switch checked-children="启用" un-checked-children="禁用" :checked="record.isRelease == 1" />
            </a-popconfirm>
        </span>

        <span v-viewer slot="picture" slot-scope="text, record">
          <video  controls width="100" height="100">
          <source :src="record.picture" type="video/mp4">
        </video>
      </span>

        <span slot="operation" slot-scope="text, record, index">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['catalogue:catalogue:edit']">
            <a-icon type="edit" />修改
          </a>
          <a @click="handleDelete(record, index)" v-hasPermi="['catalogue:catalogue:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
          <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCatalogue,listCatalogue, updateCatalogue, delCatalogue } from '@/api/catalogue/catalogue'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Catalogue',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
         //索引indexs
      indexs: [],
      loading: false,
      total: 0,
      current: 0,
      size: 0,
      // 查询参数
      queryParam: {
        courseId: null,
        courseName: null,
        section: null,
        name: null,
        picture: null,
        type: null,
        andSee: null,
        sort: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
        },
        {
          title: '课程名称',
          dataIndex: 'courseName',
          align: 'center'
        },
        {
          title: '第几节',
          dataIndex: 'section',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '标题',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '课程视频',
        //   dataIndex: 'picture',
        //   ellipsis: true,
        //   scopedSlots: {customRender: 'picture'},
        //   align: 'center'
        // },
        {
          title: '类型 ',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender:function (text) {
            if (text == 0) {
              return "会员可看";
            } else {
              return "非会员可看";
            }
          }
        },
        {
          title: '试看 ',
          dataIndex: 'andSee',
          ellipsis: true,
          align: 'center',
          customRender:function (text) {
            if (text == 0) {
              return "可以试看";
            } else {
              return "不能试看";
            }
          }
        },
        {
          title: '排序',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'isRelease',
          ellipsis: true,
          align: 'center',
          width: 80,
          scopedSlots: {customRender: 'isRelease'}
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        },

        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  activated () {
    
    this.queryParam.courseId = this.$route.query.hasOwnProperty('courseId')?this.$route.query.courseId:null
    
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询课程目录列表 */
    getList () {
      this.loading = true
     pageCatalogue(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        courseId: undefined,
        courseName: undefined,
        section: undefined,
        name: undefined,
        picture: undefined,
        type: undefined,
        andSee: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      // 列表顶部删除indexs
      if(this.selectedRowKeys.length){
        const indexList = this.selectedRowKeys.map(item=>{
          return this.list.findIndex(i=>i.id === item)
        })
        this.indexs = indexList.filter(item=>item!==-1).map(ind=>{
          return (this.current - 1) * this.size + ind + 1
        })
      }
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    confirmRelease(record,isRelease) {
      updateCatalogue({id:record.id,isRelease:isRelease == 1?0:1}).then(res=>{
        this.$message.success("操作成功")
        this.getList()
      })
    },
       /** 取消不做操作 */
       cancelRelease() {
        
      },
    /** 删除按钮操作 */
    handleDelete(row,index) {
      var that = this
      const ids = row.id || this.ids
      const inds = (this.current - 1) * this.size + index + 1
      const indexs = inds || this.indexs.sort((a, b) => a - b)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + indexs + '的数据',
        onOk() {
          let data = []
          if(row.id){
                data.push({"id":row.id})
              }else {
                that.ids.map(id => data.push({"id":id}))
              }
          return delCatalogue(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('catalogue/catalogue/export', {
            ...that.queryParam
          }, `课程目录_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
